import posthog from 'posthog-js'

export class PostHogService {
  private isInitialized = false

  /**
   * Initialize PostHog
   */
  initialize() {
    if (this.isInitialized) {
      console.warn('Pulse is already initialized')
      return
    }

    const posthogKey = import.meta.env.VITE_POSTHOG_KEY
    const posthogHost = import.meta.env.VITE_POSTHOG_HOST

    if (!posthogKey) {
      console.warn('Pulse key is not configured')
      return
    }

    if (this.isInitialized) {
      return
    }

    posthog.init(posthogKey, {
      api_host: posthogHost,
      loaded: posthog => {
        if (import.meta.env.DEV) {
          console.log('Pulse loaded:', posthog)
        }
      },
    })

    this.isInitialized = true
  }

  /**
   * Identify a user
   */
  identify(userId: string, properties?: Record<string, unknown>) {
    if (!this.isInitialized) {
      console.warn('Pulse is not initialized')
      return
    }
    posthog.identify(userId, properties)
  }

  group(groupType: string, groupId: string) {
    if (!this.isInitialized) {
      console.warn('Pulse is not initialized')
      return
    }
    posthog.group(groupType, groupId)
  }

  /**
   * Track an event
   */
  capture(eventName: string, properties?: Record<string, unknown>) {
    if (!this.isInitialized) {
      console.warn('Pulse is not initialized')
      return
    }
    posthog.capture(eventName, properties)
  }

  /**
   * Reset user identity (for logout)
   */
  reset() {
    if (!this.isInitialized) {
      return
    }
    posthog.reset()
  }

  /**
   * Check if PostHog is initialized
   */
  get initialized() {
    return this.isInitialized
  }
}

// Export a singleton instance
export const posthogService = new PostHogService()
